import { ConsentType } from '@csp/dmdp-api-user-dto';

export type PatientLegacyConsentType = ConsentType.EULA | ConsentType.PRIVACY_POLICY;

export const PatientLegacyConsentTypes: PatientLegacyConsentType[] = [ConsentType.EULA, ConsentType.PRIVACY_POLICY];
